/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { Select } from '@ui/components';

const fruitOptions = [
    { label: 'Apple', value: 'apple' },
    { label: 'Banana', value: 'banana' },
    { label: 'Cherry', value: 'cherry' },
];

const longOptions = Array.from({ length: 50 }, (_, index) => ({
    label: `Option ${index + 1}`,
    value: `option-${index + 1}`,
}));

export const DefaultSelectExample = () => (
    <Select
        options={fruitOptions}
        placeholder="Select a fruit"
        style={{ width: '100%' }}
    />
);

export const MultipleSelectExample = () => (
    <Select
        mode="multiple"
        options={fruitOptions}
        placeholder="Select fruits"
        style={{ width: '100%' }}
    />
);

export const DisabledSelectExample = () => (
    <Select
        disabled
        options={fruitOptions}
        placeholder="Disabled"
        style={{ width: '100%' }}
    />
);

export const LoadingSelectExample = () => (
    <Select
        loading
        options={fruitOptions}
        placeholder="Loading options"
        style={{ width: '100%' }}
    />
);

export const LongOptionListSelectExample = () => (
    <Select
        options={longOptions}
        placeholder="Select an option"
        showSearch
        style={{ width: '100%' }}
    />
);

export const EmptySelectExample = () => (
    <Select options={[]} placeholder="No options available" style={{ width: '100%' }} />
);
